import React, { useState, useEffect } from "react";
function AddOperator() {
    return (
        <div className="content-wrapper">
            <div className="container-fluid">
            <div className="content-header pt-1 ">
                <div className="mt-3 border-bottom">
                    <div className="fs-4 valuesDec h5">ADD NEW OPERATOR</div>
                </div>
              
                <div className="mx-1 p-1 border-0  " >
                    <form action="#" method="post">
                        <div className="row  my-0" >
                        
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="customerName" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Network Name</label>
                                    <input type="text" name="networkName" id="networkName" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter networkurl here" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="boxType" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Username:</label>
                                    <input type="text" name="username" id="username" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter username" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="accountNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Password</label>
                                    <input type="text" name="password" id="password" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter password" />
                                </div>
                            </div>
                           
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="MobileNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Mobile Number</label>
                                    <input type="text" name="MobileNumber" id="MobileNumber" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter box  amount" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="OfficeNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Office Number(For SMS)</label>
                                    <input type="text" name="OfficeNumber" id="OfficeNumber" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter box  amount" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="GpayNumber" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>GooglePay Number(For SMS)</label>
                                    <input type="text" name="GpayNumber" id="GpayNumber" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter box  amount" />
                                </div>
                            </div>
                          
                           
                           
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="email" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Email Id</label>
                                    <input type="number" name="email" id="email" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter phone number" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="networkurl" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Network URL Path</label>
                                    <input type="text" name="networkurl" id="networkurl" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter door number" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="code" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Code(Customer Code Prefix)</label>
                                    <input type="number" name="code" id="code" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter alternate mobile number" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="softwareamount" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Software Amount <span className="text-success">(default)</span></label>
                                    <input type="number" name="softwareamount" id="softwareamount" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter alternate mobile number" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="status" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Payment status</label>
                                    <select className="form-control bg-gradient-light text-navy border-dark elevation-3" id="status" name="status">
                                        <option value="none">none</option>
                                        <option value="paid">paid</option>
                                        <option value="unpaid">Unpaid</option>
                                    </select>
                                </div>
                            </div>
                           
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="date" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Paid Date</label>
                                    <input type="date" name="date" id="date" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter package" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="usernamedb" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Username(DataBase)</label>
                                    <input type="name" name="usernamedb" id="usernamedb" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter discount amount" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="passworddb" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>Password(DataBase)</label>
                                    <input type="password" name="passworddb" id="passworddb" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter discount amount" />
                                </div>
                            </div>
                            <div className="col-lg-4 col-12 ">
                                <div className="form-group">
                                    <label htmlFor="dbname" className="text-center valuesDec text-navy" style={{ height: "2.4rem" }}>DataBase Name</label>
                                    <input type="text" name="dbname" id="dbname" className="form-control bg-gradient-light text-navy border-dark elevation-3" placeholder="enter discount amount" />
                                </div>
                            </div>
                        </div>
                        <div className="text-center mt-4">
                        <input type="submit" value="Submit" className="btn btn-success p-2 text-bold" />
                        </div>
                    </form>
                </div>
            </div>
            </div>
        </div>
    );
}
export default AddOperator;